import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isNil } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { NumberInput, Typography } from '@dev/ee-components';
import { FormPopupTriggerEnum } from '@/store/formCreator/types';
import { SetPopupDelay, SetPopupTrigger, getFormCreatorStore } from '@/store/formCreator/actions';
import { Step5EditContentWrapper, Step5EditInputWrapper } from './styles';
import { FORM_POPUP_DEFAULT_DELAY, FORM_POPUP_MAX_DELAY, FORM_POPUP_MIN_DELAY } from '../../constants';
export const ALPHA_NUMERIC_REGEX = /[0-9]+/;

export const checkIsNumericValue = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!ALPHA_NUMERIC_REGEX.test(e.key)) {
        return e.preventDefault();
    }
};

const checkMinMaxValue  = (value: number, min: number, max: number): number => {
    if (typeof min === 'number' && value < min) {
        return min;
    }
    if (typeof max === 'number' && value > max) {
        return max;
    }
    return value;
};

export const Step5EditContent = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { popupDelay: value } = useSelector(getFormCreatorStore);

    const setValue = (value: number) => {
        dispatch(SetPopupDelay(value));
        dispatch(SetPopupTrigger(FormPopupTriggerEnum.Delay));
    };

    useEffect(() => {
        if (isNil(value)) {
            setValue(FORM_POPUP_DEFAULT_DELAY);
        }
    }, []);

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>, value: number): void => {
        setValue(value);
    };
    
    const onInputBlur = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (value as unknown as string === '') {
            setValue(FORM_POPUP_MIN_DELAY);
            return;
        }
        setValue(checkedValue(Number(e.target?.value)));
    };
    
    const handleKeyPress = (e) => {
        if (e.keyCode === 13 || e.key === 'Enter') return onInputBlur(e);
        checkIsNumericValue(e);
    };

    const checkedValue = (width: number) => checkMinMaxValue(width, FORM_POPUP_MIN_DELAY, FORM_POPUP_MAX_DELAY);

    const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        if (Number(e.target.value) === FORM_POPUP_MIN_DELAY) setValue(('' as undefined) as number);
    };

    return (
        <Step5EditContentWrapper>
            <Typography variant="body1">{t('popupdelayinseconds_description')}</Typography>
            <Step5EditInputWrapper>
                <Typography variant="h4">{t('popupdelayinseconds')}</Typography>
                <NumberInput
                    name="borderWidth-input"
                    id="borderWidth-input"
                    min={FORM_POPUP_MIN_DELAY}
                    max={FORM_POPUP_MAX_DELAY}
                    value={value}
                    onChange={onInputChange}
                    onFocus={handleOnFocus}
                    onBlur={onInputBlur}
                    onKeyPress={handleKeyPress}
                />
            </Step5EditInputWrapper>
        </Step5EditContentWrapper>
    );
};
